import red from '../../../res/red.png';
import black from '../../../res/black.png';
import yellow from '../../../res/yellow.png';
import turquoise from '../../../res/turquoise.png';
import green from '../../../res/green.png';
import orange from '../../../res/orange.png';
import pink from '../../../res/pink.png';
import purple from '../../../res/purple.png';

export const pictures = [
    {
        src: red,
        name: 'couleur rouge',
    },

    {
        src: black,
        name: 'couleur noire',
    },

    {
        src: yellow,
        name: 'couleur jaune',
    },

    {
        src: turquoise,
        name: 'couleur turquoise',
    },
    
    {
        src: green,
        name: 'couleur verte',
    },

    {
        src: orange,
        name: 'couleur orange',
    },

    {
       src: pink,
        name: 'couleur rose',
    },

    {
        src: purple,
        name: 'couleur violette',
    }
];